import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface AnimatedSectionProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
export function AnimatedSection({
  children,
  delay = 0,
  className
}: AnimatedSectionProps) {
  const prefersReducedMotion = useReducedMotion();
  return <motion.div className={className} initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true,
    amount: 0
  }} transition={{
    duration: prefersReducedMotion ? 0.3 : 0.7,
    delay,
    // ease-in-out: rallenta sia all'inizio che alla fine
    ease: [0.45, 0, 0.55, 1]
  }} style={{
    willChange: 'opacity'
  }} data-id="element-17">
      {children}
    </motion.div>;
}